import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import {
  FLink,
  Table,
  CurrencyTextInput,
  TableMobile,
  Datepicker,
  Button,
  LoadingIndicator,
} from '@components';
import { currency } from '@utils';
import { useSelector } from 'react-redux';
import { addDays, format } from 'date-fns';
import { CONTRATOS_ABSOLUTE_PATH } from '../../../../../common/utils/paths';
import { EmprestimoService } from '../../../../../common/services/emprestimo';

const service = new EmprestimoService();

export const Antecipacao = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [valor, setValor] = useState(0);
  const [parcelas, setParcelas] = useState('0');
  const [dataPagamento, setDataPagamento] = useState(new Date());
  const [dataFormatada, setDataFormatada] = useState('');

  const [loading, setLoading] = useState(false);
  const [simulou, setSimulou] = useState(false);

  const {
    matricula,
    token,
    dadosPessoais: { email },
  } = useSelector((state) => state.user);

  const {
    vlrSolicitado,
    parcTotal,
    parcPagas,
    ultimaParcela,
    vlrSaldoDevedor,
    totalParcelasEmAtraso,
    valorTotalEmAtraso,
  } = location.state;

  useEffect(() => {
    setDataFormatada(format(dataPagamento, 'yyyy-MM-dd'));
  }, [dataPagamento]);

  const valorEmCentavos = (valor * 100).toFixed(0);

  const geraBoletoAntecipacao = () => {
    service
      .emitirBoletoEmprestimo({
        matricula,
        email,
        numeroContrato: id,
        token,
        dataVencimento: dataFormatada,
        valor: valorEmCentavos,
        tipoPagamento: 'Antecipação',
      })
      .then((res) => {
        const blob = new Blob([res], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `Boleto Antecipação - ${matricula}.PDF`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  };

  return (
    <div className="card">
      <div className="card-body pb-3">
        <FLink
          className="justify-content-start mb-32"
          iconLeft="icon-arrow_back"
          onClick={() => navigate(CONTRATOS_ABSOLUTE_PATH)}
        >
          voltar
        </FLink>
        <h3 className="ts-20 fw-bold text-black mb-2">
          Antecipação do contrato: {id}
        </h3>
        <p className="ts-14 text-muted mb-32">
          Modalidade de pagamento em que o prazo final do contrato é reduzido e
          o valor da parcela mantido. Não pode ocorrer mais de um pagamento
          dentro do mês corrente.
        </p>
        <Table
          className="is-desktop mb-32"
          large
          odd
          columns={[
            'Valor',
            'Parcelas',
            'Lançadas',
            'Última',
            'Saldo devedor',
            'Atrasadas',
            'Valor em atraso',
          ]}
        >
          <tr>
            <td className="ts-20">{currency(vlrSolicitado)}</td>
            <td className="ts-20">{parcTotal}</td>
            <td className="ts-20">{parcPagas}</td>
            <td className="ts-20">{currency(ultimaParcela)}</td>
            <td className="ts-20">{currency(vlrSaldoDevedor)}</td>
            <td className="ts-20">{totalParcelasEmAtraso}</td>
            <td className="ts-20">{currency(valorTotalEmAtraso)}</td>
          </tr>
        </Table>
        <TableMobile className="mb-32">
          <div className="col-6">
            <div className="thead">Valor</div>
            <div className="td">{currency(vlrSolicitado)}</div>
          </div>
          <div className="col-6">
            <div className="thead">Parcelas</div>
            <div className="td">{parcTotal}</div>
          </div>
          <div className="col-6">
            <div className="thead">Lançadas</div>
            <div className="td">{parcPagas}</div>
          </div>
          <div className="col-6">
            <div className="thead">Última</div>
            <div className="td">{currency(ultimaParcela)}</div>
          </div>
          <div className="col-6">
            <div className="thead">Saldo devedor</div>
            <div className="td">{currency(vlrSaldoDevedor)}</div>
          </div>
          <div className="col-6">
            <div className="thead">Atrasadas</div>
            <div className="td">{totalParcelasEmAtraso}</div>
          </div>
          <div className="col-12">
            <div className="thead">Valor em atraso</div>
            <div className="td">{currency(valorTotalEmAtraso)}</div>
          </div>
        </TableMobile>
        <div className="row">
          <div className="is-desktop col-12 col-md-5 col-lg-4">
            <CurrencyTextInput
              height={56}
              fontSize="ts-16 border-50"
              label="Qual valor deseja antecipar"
              value={valor}
              onChange={(value) => setValor(value)}
            />
          </div>
          <div className="is-mobile col-12 col-md-5 col-lg-4 mb-32">
            <CurrencyTextInput
              label="Qual valor deseja antecipar"
              value={valor}
              onChange={(value) => setValor(value)}
            />
          </div>
          <div className="col-12 col-md-3 col-lg-3 mb-32 mb-md-32">
            <Datepicker
              label="Data de pagamento"
              value={dataPagamento}
              min={new Date()}
              max={addDays(new Date(), 1)}
              onChange={setDataPagamento}
            />
          </div>

          <Button
            onClick={() => {
              setLoading(true);

              service
                .obterCalcularAntecipacao({
                  contrato: id,
                  matricula,
                  token,
                  valor,
                })
                .then((res) => setParcelas(res))
                .finally(() => {
                  setLoading(false);
                  setSimulou(true);
                });
            }}
          >
            Simular antecipação
          </Button>
        </div>
      </div>

      {loading ? (
        <LoadingIndicator />
      ) : (
        simulou && (
          <div className="card-body">
            <div className="row">
              <hr className="mb-32" />
              <h4 className="fs-3 mb-3 fw-bold">Resultado da simulação:</h4>
              <div className="d-flex">
                <p className="fs-5 mb-2 flex-1">
                  Quantidade de parcelas: {Number(parcelas)}
                </p>
              </div>
            </div>
          </div>
        )
      )}

      <div className="card-footer">
        <hr className="mb-32" />
        <div className="row">
          {!loading && simulou && Number(parcelas) ? (
            <div className="col-12 col-sm-6 col-md-4 ms-0 ms-sm-auto">
              <Button
                onClick={geraBoletoAntecipacao}
                transparent
                color="orange"
              >
                Gerar boleto
              </Button>
            </div>
          ) : (
            simulou &&
            !loading && (
              <p>Você não pode gerar um boleto que antecipa zero parcelas.</p>
            )
          )}
        </div>
      </div>
    </div>
  );
};
